module.exports = __webpack_public_path__ + "img/spin_btn.4f9a49c0.png";